import React, { useEffect, useState } from 'react';
import { Tabs, Grid } from '@mui/material';
import {
  ActionContainer, TabPanel, AppBarContainer, CancelButton, ConfirmButton,
  MainContainer, MoreButton, TabContainer, Title
} from './styled';
import { MessageTypeConstants } from '../../../../services/bot/Message';
import store from '../../../../state/configureStore';
import FMForm from '../../FMForm';
import FMTable from '../../FMTable';
import FMCalendar from '../../FMCalendar';


const FMContainerComponent = ({
  conversation,
  options,
  message,
  handleConfirm,
  containerSelectedTabIndex = 0,
  handleChangeTab,
  handleCancel,
  handleMoreItem,
  messageType,
  parentTabId
}) => {

  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [ismandatoryNotFilled, setIsmandatoryNotFilled] = useState(false);
  const [isvalidationFailing, setIsvalidationFailing] = useState(false);
  const [isAnyRowEditMode, setIsAnyRowEditMode] = useState(false);
  const [isLookupInvalidSearch, setIsLookupInvalidSearch] = useState(false);
  const [isTableInSectionEditMode, setIsTableInSectionEditMode] = useState(false);
  const userDomain = store.getState().domain?.userDomain || null
  const selectedTabMessage = message[containerSelectedTabIndex] || message[message.length - 1];

  useEffect(() => {
    let isMandatory = false;
    let isRowEditMode = false;
    let isTableEditSection = false;
    let isLookup = false;
    let isNotValid = false;
    message.forEach((containerTabs) => {
      const msg = containerTabs.message;
      if (containerTabs.type === MessageTypeConstants.MESSAGE_TYPE_TABLE) {
        if (msg.rows && msg.rows.length) {
          msg.rows.forEach((row) => {
            if (
              Object.values(row)[0].rowOptions?.editRow === true || Object.values(row)[0].rowOptions?.newRow === true
            ) {
              isRowEditMode = true;
            }
          });
        }
      }

      if (containerTabs.type === MessageTypeConstants.MESSAGE_TYPE_FORM2) {
        if (msg?.collectionData) {
          const collectionDataContent = Object.values(msg.collectionData) || [];
          if (collectionDataContent.length) {
            collectionDataContent.forEach((eachObj) => {
              eachObj?.rows?.forEach((eachRow) => {
                const { rowOptions } = Object.values(eachRow)[0];
                if (rowOptions && rowOptions.editRow) {
                  isTableEditSection = true
                }
              });
            });
          }
        }

        if (msg.fields && msg.fields.length) {
          // validationCheck
          msg.fields.forEach((eachObject) => {
            if (
              eachObject?.validation && eachObject?.validationResult === false
            ) {
              isNotValid = true;
            }

            // lookup check
            if (eachObject?.type === 'lookup') {
              if (eachObject.value !== '') {
                if (eachObject?.results?.length > 0) {
                  const resultValues = [];
                  eachObject.results.forEach((eachResult) => {
                    resultValues.push(eachResult.text);
                  });

                  if (!resultValues.includes(eachObject.value)) {
                    isLookup = true;
                  }
                }
              }
            }

            // mandatory check
            if (eachObject?.mandatory === true) {
              if (
                !eachObject.value || eachObject.value == null || eachObject.value === '' || eachObject.value === undefined
              ) {
                isMandatory = true;
              }
            }
          });
        }
      }
    });
    setIsAnyRowEditMode(isRowEditMode);
    setIsmandatoryNotFilled(isMandatory);
    setIsTableInSectionEditMode(isTableEditSection);
    setIsLookupInvalidSearch(isLookup);
    setIsvalidationFailing(isNotValid);
  });

  useEffect(() => {
    if (
      isAnyRowEditMode || isvalidationFailing || ismandatoryNotFilled || isLookupInvalidSearch || isTableInSectionEditMode
    ) {
      setIsSubmitDisabled(true);
    } else {
      setIsSubmitDisabled(false);
    }
  }, [isAnyRowEditMode, isvalidationFailing, ismandatoryNotFilled, isLookupInvalidSearch, isTableInSectionEditMode]);

  const hadleMainConfirm = () => {
    const tabType = selectedTabMessage?.type;
    if (tabType === MessageTypeConstants.MESSAGE_TYPE_FORM || tabType === MessageTypeConstants.MESSAGE_TYPE_FORM2) {
      const fieldMessages = selectedTabMessage?.message;
      const collectionData = fieldMessages.collectionData;
      handleConfirm(collectionData);
    } else {
      handleConfirm();
    }
  }


  const renderContent = (index) => {
    const tabType = selectedTabMessage?.type;
    const fieldMessages = selectedTabMessage?.message;

    switch (tabType) {
      case MessageTypeConstants.MESSAGE_TYPE_FORM:
      case MessageTypeConstants.MESSAGE_TYPE_FORM2:

        //format message { fields :} according type [] or {} if its containing sections then it will be object else array containing fields

        let normalizedMessage = {
          message: {
            fields: [],
            options: {},
          },
        };

        if (Array.isArray(fieldMessages.fields)) {
          normalizedMessage = fieldMessages;
        } else if (fieldMessages && typeof fieldMessages.fields === 'object') {
          normalizedMessage = {
            ...fieldMessages.fields,
          };
        }

        const messageObj = {
          message: normalizedMessage,
          options: fieldMessages.options,
          conversation,
          parentMessageType: messageType,
          parentTabId: options.tabId,
          parentDocId: options.docId || selectedTabMessage?.message?.options?.parentDocId
        };

        return (
          <FMForm message={messageObj} parentTabIdKey={parentTabId} />
        );

      case MessageTypeConstants.MESSAGE_TYPE_TABLE:
        return (
          <FMTable
            message={selectedTabMessage?.message}
            parentTabId={parentTabId}
            parentDocId={options?.docId || selectedTabMessage?.message?.options?.parentDocId}
            conversation={conversation}
          />
        );

      case MessageTypeConstants.MESSAGE_TYPE_MAP:
        return (
          <FMCalendar
            noFullScreencontrol
            message={selectedTabMessage?.message?.rows}
            parentTabId={options.tabId}
            parentDocId={options.docId}
            conversation={conversation}
            inContainer
            options={selectedTabMessage?.message?.options}
            messageType={selectedTabMessage?.type}
            mapContainer={`scrollable-auto-tab-panel-${tabType}-${index}`} />
        );

      default:
        break;
    }
  };

  return (
    <MainContainer>
      {options.style !== "Breadcrumb" && message.length >= 2 ? (
        <>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <div className="text-size-14 font-semibold text-black ml-3 mb-0 mt-3">
              {options?.title || ""}
            </div>
          </Grid>

          <AppBarContainer position="static" color="default" className="!mb-2">
            <Tabs
              slotProps={{
                indicator: { style: { backgroundColor: "#638dff" } },
              }}
              value={containerSelectedTabIndex}
              onChange={handleChangeTab}
              textColor="secondary"
              variant="scrollable"
              aria-label="full width tabs example"
            >
              {message.map((item, index) => (
                <TabContainer
                  key={`${item.message?.options?.title || 'tab'}-${index}`}
                  userDomain={userDomain}
                  label={item.message?.options?.title || `Tab ${index + 1}`}
                  sx={{
                    "&.Mui-selected": {
                      color: "#638dff",
                    },
                  }}
                />
              ))}
            </Tabs>
          </AppBarContainer>

          {message.map((item, index) => (
            <TabPanel
              key={`${item?.type || 'panel'}-${index}`}
              index={index}
              value={containerSelectedTabIndex}
              tabType={item?.type}
              className="custome"
            >
              {renderContent(index)}
            </TabPanel>
          ))}
        </>
      ) : (
        renderContent(0)
      )}


      <ActionContainer
        container
        spacing={2}
        marginBottom='6px'
        marginTop='20px'
        marginLeft='30px'
        paddingBottom='8px'
        justifyContent='left'
        ismore={(options.more && options.more.length > 0).toString()}
      >

        {options.more && options.more?.map((item) => (
          <Grid key={`${item}`}>
            <MoreButton
              variant='contained'
              disabled={isAnyRowEditMode}
              onClick={() => handleMoreItem(item)}>
              {item}
            </MoreButton>
          </Grid>
        ))}

        {options.confirm && (
          <Grid>
            <ConfirmButton
              variant='contained'
              disabled={isSubmitDisabled}
              onClick={() => hadleMainConfirm()}
            >
              {options.confirm}
            </ConfirmButton>
          </Grid>
        )}

        {options.cancel && (
          <Grid>
            <CancelButton
              variant='outlined'
              disabled={isAnyRowEditMode}
              onClick={() => handleCancel()}
            >
              {options.cancel}
            </CancelButton>
          </Grid>
        )}
      </ActionContainer>
    </MainContainer>
  );
};

export default FMContainerComponent;
